const formatDate = ({ $moment, date, format = 'DD/MM/YYYY' }) => {
  if (!date) {
    return ''
  }

  return $moment(date).format(format)
}

export default formatDate
